import { TicketAutorizacionTransporteService } from './../../services/ticket-autorizacion-transporte.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Subscription } from "rxjs";
import { first, map } from "rxjs/operators";
import {LfsaBotonEditarGridComponent} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { MantenimientoGaritasService } from '../../services/mantenimiento-garitas.service';
import { IGaritaResponse } from '../../modelos/IMantGarita';
import { Row, Workbook as wb, Worksheet } from "exceljs";
import { saveAs } from 'file-saver';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-reporte-garita',
  templateUrl: './reporte-garita.component.html',
  styleUrls: ['./reporte-garita.component.css']
})
export class ReporteGaritaComponent implements OnInit {

  public DAT_TITULOS  : any = moduloGaritas.titulos.reporteCompras;
  public DAT_BTNS     : any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS   : any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID  : any = moduloGaritas.agGrid;
  public DAT_MSG      : any = moduloGaritas.mensajes;

  public gridApi      : any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs   : any[] = [];
  public rowData      : any[] = [];

  public loading    : boolean = false;

  workbook  : wb;
  data      : any = [];
  dataExcel : any = [];

  public agregarForm = new FormGroup({
    idTicket    : new FormControl(),
    ticketId    : new FormControl(),
    garitaId    : new FormControl(),
    tipo        : new FormControl(),
    fechaInicio : new FormControl('',  [Validators.required]),
    fechaFin    : new FormControl('',  [Validators.required]),
    proveedorTranspId: new FormControl(),
  });

  public cmbxTipo = [
    {clave: '1', valor: 'Contratado'},
    {clave: '2', valor: 'Vehículo Propio'},
    {clave: '3', valor: 'Ocasional'},
    {clave: '4', valor: 'Importaciones'},
  ]; 

  public cmbxGarita: IGaritaResponse[] = [];

  private subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private garitasService: MantenimientoGaritasService,
    private ticketService : TicketAutorizacionTransporteService,
  ) {
  }

  ngOnInit(): void {
    this.gridComponent();
    this.inicializarCombos();
  }

  inicializarCombos(){
    //Obtiene Garitas
    this.loading = true;
    this.garitasService.obtener()
      .pipe(map(m => m.filter(f => f.estado.toString() == 'ACTIVO')))
      .subscribe(
        (resp) => {
          this.cmbxGarita = resp;
          this.loading = false;
        },
        (error) => {
          this.cmbxGarita = [];
          this.loading = false;
        }
      );
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {sortable: true, resizable: true, filter: true, suppressSizeToFit: true, field: 'idAuthTransp', headerName: 'TICKET GARITA'},
      {sortable: true, resizable: true, filter: true, suppressSizeToFit: true, field: 'estadoControlEntrada', headerName: 'ESTADO DE INGRESO',
        cellRenderer: (data) => { 
          return data.value == 1 ? "VEHÍCULO INGRESO" : "VEHÍCULO SALIO"
        }
      },
      {sortable: true, resizable: true, filter: true, suppressSizeToFit: true, field: 'idGarita.idGarita', headerName: 'Garita Id'},
      {sortable: true, resizable: true, filter: true, suppressSizeToFit: true, field: 'idGarita.desca', headerName: 'Garita Descripción'},
      {sortable: true, resizable: true, filter: true, suppressSizeToFit: true, field: 'ordenFlete'},
      {sortable: true, resizable: true, filter: true, suppressSizeToFit: true, field: 'fechaLlegada', headerName: 'Fecha real llegada'},
      {sortable: true, resizable: true, filter: true, suppressSizeToFit: true, field: 'fecha', headerName: 'Fecha Ingreso',
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy', 'en') : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'fecha', headerName: 'Hora Ingreso', suppressSizeToFit: true,
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'HH:mm:ss', 'en') : '' 
        }
      },
      {sortable: true, resizable: true, filter: true, field: 'fechaSalida', headerName: 'Fecha Salida', suppressSizeToFit: true,
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy', 'en') : ''
        }
      },
      {sortable: true, resizable: true, filter: true, field: 'fechaSalida', headerName: 'Hora', suppressSizeToFit: true,
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy', 'en') : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'authOrigenId', headerName: 'TICKET GARITA ORIGEN'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'origenGarita', headerName: 'ORIGEN NARITA'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'origenFecha', headerName: 'ORIGEN Fecha Ingreso',
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy', 'en') : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'origenFecha', headerName: 'ORIGEN Hora Ingreso',
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'HH:mm:ss', 'en') : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'origenFechaSalida', headerName: 'ORIGEN Fecha Salida',
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy', 'en') : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'origenFechaSalida', headerName: 'ORIGEN Hora Salida',
        cellRenderer: (data) => { 
          return data.value ? formatDate(new Date(data.value), 'HH:mm:ss', 'en') : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'obRelacionada',  headerName: 'ORIGEN OB RELACIONADA'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'cliente', 
        cellRenderer: (data) => { 
          console.log(data);
          return data.value ? data.value + ' ' + data.data.dscaCliente : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'proveedor'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'placa'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'proveedorTransp', 
        cellRenderer: (data) => { 
          console.log(data);
          return data.value ? data.value + ' ' + data.data.dscaProvTransporte : ''
        }
      },
      {sortable: true, resizable: true, filter: true, width: 200, field: 'chofer',},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'lugarSalida'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'lugarLlegada'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'pesoBrutoRecibido'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'sellos'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'referenciaProducto'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'usuario'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'observacion'},
      {sortable: true, resizable: true, filter: true, width: 200, field: 'facturaGuia'}
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //params.api.sizeColumnsToFit();
  }

  descargarExcel() {
    this.dataExcel = [];
    this.workbook = new wb();

    this.rowData.forEach(x => {
      let payload = {
        idAuthTransp        : x.idAuthTransp,
        estadoControlEntrada: x.estadoControlEntrada == 1 ? "VEHÍCULO INGRESO" : "VEHÍCULO SALIO",
        idGarita            : x.idGarita.idGarita,
        idGarita_desca      : x.idGarita.desca,
        ordenFlete          : x.ordenFlete,
        fechaLlegada        : x.fechaLlegada,
        ingreso_fecha       : x.fecha ? formatDate(new Date(x.fecha), 'dd-MM-yyyy', 'en') : '',
        ingreso_hora        : x.fecha ? formatDate(new Date(x.fecha), 'HH:mm:ss', 'en') : '' ,
        fechaSalida         : x.fechaSalida ? formatDate(new Date(x.fechaSalida), 'dd-MM-yyyy', 'en') : '',
        fechaSalida_hora    : x.fechaSalida ? formatDate(new Date(x.fechaSalida), 'HH:mm:ss', 'en') : '' ,
        authOrigenId        : x.authOrigenId,
        origenGarita        : x.origenGarita,
        fechaOrigen         : x.origenFecha ? formatDate(new Date(x.origenFecha), 'dd-MM-yyyy', 'en') : '',
        horaOrigen          : x.origenFecha ? formatDate(new Date(x.origenFecha), 'HH:mm:ss', 'en') : '' ,
        fSaidaOrigen        : x.origenFechaSalida ? formatDate(new Date(x.origenFechaSalida), 'dd-MM-yyyy', 'en') : '',
        hSalidaOrigen       : x.origenFechaSalida ? formatDate(new Date(x.origenFechaSalida), 'HH:mm:ss', 'en') : '' ,
        obRelacionado       : x.obRelacionada,
        cliente             : x.cliente ? x.cliente +' '+ x.dscaCliente : '',
        proveedor           : x.proveedor,
        placa               : x.placa,
        proveedorTransp     : x.proveedorTransp ? x.proveedorTransp +' '+ x.dscaProvTransporte : '',
        chofer              : x.chofer,
        lugarSalida         : x.lugarSalida,
        lugarLlegada        : x.lugarLlegada,
        pesoBrutoRecibido   : x.pesoBrutoRecibido,
        sellos              : x.sellos,
        referenciaProducto  : x.referenciaProducto,
        usuario             : x.usuario,
        observacion         : x.observacion,
        facturaGuia         : x.facturaGuia,
      };      
      this.dataExcel.push(payload);
    });

    console.log("this.dataExcel", this.dataExcel);

    this.fillExcelMarketplace();
    this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Reporte Garita' + '.xlsx');
    });
  }

  public date = new Date();
  fillExcelMarketplace() {
    const nameSheet = 'Reporte';
    let header;
    let titulos;

    header = ["TICKET GARITA","ESTADO","ID_GARITA","DESCRIPCION GARITA","ORDEN_FLETE","FECHA REAL LLEGADA",
      "FECHA INGRESO","HORA INGRESO","FECHA SALIDA","HORA SALIDA","TICKET GARITA ORIGEN","DESCRIPCION GARITA ORIGEN",
      "FECHA INGRESO","HORA INGRESO","FECHA SALIDA","HORA SALIDA","ORDEN BALANZA ORIGEN","CLIENTE","PROVEEDOR","PLACA","PROVEEDOR_TRANSPORTE",
      "CHOFER","LUGAR_SALIDA","LUGAR_LLEGADA","PESO_BRUTO_RECIBIDO","SELLOS","REFERENCIA_PRODUCTO","USUARIO","OBSERVACION","FACTURA_GUIA"];

    titulos=["REPORTE_GARITAS."];

    let row;
    let headerRow;
    let titulosRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left  : 0.3149606,
          right : 0.3149606,
          top   : 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    
    row = worksheet.getRow(1);
    titulosRow = worksheet.addRow(titulos);

    row = worksheet.getRow(2);
    titulosRow = worksheet.addRow([this.date]);

    row = worksheet.getRow(4);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 30;
    worksheet.columns[1].width = 10;
    worksheet.columns[2].width = 30;
    worksheet.columns[3].width = 10;
    worksheet.columns[4].width = 30;
    worksheet.columns[5].width = 30;
    worksheet.columns[6].width = 20;
    worksheet.columns[7].width = 30;
    worksheet.columns[8].width = 20;
    worksheet.columns[9].width = 10;
    worksheet.columns[10].width = 30;
    worksheet.columns[11].width = 10;
    worksheet.columns[12].width = 20;
    worksheet.columns[13].width = 20;
    worksheet.columns[14].width = 20;
    worksheet.columns[15].width = 15;
    worksheet.columns[16].width = 15;
    worksheet.columns[17].width = 15;
    worksheet.columns[18].width = 15;
    worksheet.columns[19].width = 15;
    worksheet.columns[10].width = 15;
    worksheet.columns[21].width = 15;
    worksheet.columns[22].width = 15;
    worksheet.columns[23].width = 15;
    worksheet.columns[24].width = 15;
    worksheet.columns[25].width = 15;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {vertical: 'middle', horizontal: 'right'};
      });
    });

    this.data = this.formatDataExcel();
    this.fillRows(worksheet);
    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }


  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'B7DEE8' },
            bgColor: { argb: 'FF0000FF' },
          };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatDataExcel(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }

  buscarReporte() {

    let datos = this.agregarForm.getRawValue();

    if ((datos.fechaFin == "" || datos.fechaFin == null) && (datos.fechaInicio == "" || datos.fechaInicio == null)) {
      this._util.alertifyToastWar("Necesita al menos filtrar por fechas");
      return;
    }

    this.loading = true;
    datos.idTicket =  datos.idTicket ? parseInt(datos.idTicket) : 0,
    datos.ticketId =  datos.ticketId ? parseInt(datos.ticketId) : 0,
    datos.garitaId =  datos.garitaId ? parseInt(datos.garitaId) : 0,
    datos.tipo     =  datos.tipo ? parseInt(datos.tipo) : 0,
    datos.proveedorTranspId =   datos.proveedorTranspId ? datos.proveedorTranspId : null,

    datos.fechaInicio = datos.fechaInicio;
    datos.fechaFin =  datos.fechaFin;

    this.subscription.add(
      this.ticketService.getReporteByFilter(datos.idTicket, datos.ticketId, datos.garitaId,
        datos.proveedorTranspId, datos.tipo, 0, datos.fechaInicio, datos.fechaFin).subscribe(
        (resp) => {
          if (resp.length > 0) {
            console.log("reporte ***", resp);
            this.rowData = resp;
          }

          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  resetCampos(){
    this.agregarForm.reset();
  }

}
